import { KYCICON, VerifiedBadge } from "@/components/bnp-icons";
import { IconX } from "@tabler/icons-react";
import { KycStatus } from "./constants";
import {
  getKycStatusMeta,
  STATUS_VARIANT_CLASSES,
} from "@/utils/getDocumentStatusLabel";

const KYCHeader = ({
  kycStatus,
  onClose,
}: {
  kycStatus?: KycStatus;
  onClose?: () => void;
}) => {
  const meta = getKycStatusMeta(kycStatus);

  return (
    <div className="relative bg-white p-4 sm:p-5 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-[#E8F2F4] flex items-center justify-center text-[#153e46] shrink-0">
          <KYCICON />
        </div>
        <div>
          <h1 className="text-slate-900 font-bold text-sm sm:text-base tracking-tight leading-tight">
            KYC Verification
          </h1>
          <p className="text-[11px] sm:text-xs text-slate-400 mt-0.5 leading-tight">
            Manage your identity documents and verification status
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 self-start sm:self-center shrink-0">
        <span
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] sm:text-xs font-semibold shrink-0 border ${STATUS_VARIANT_CLASSES[meta.variant]}`}
        >
          {meta.variant === "success" ? (
            <VerifiedBadge width={14} height={14} />
          ) : meta.variant === "pending" ? (
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
          ) : meta.variant === "rejected" ? (
            <span className="w-2 h-2 rounded-full bg-rose-500" />
          ) : (
            <span className="w-2 h-2 rounded-full bg-slate-400" />
          )}
          {meta.label}
        </span>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute top-0 right-3 w-8 h-8 rounded-lg flex items-center justify-center text-slate-500 hover:text-slate-800 transition-colors shrink-0"
          >
            <IconX className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default KYCHeader;
